module.exports = __webpack_public_path__ + "static/media/leaflet_clc_naming_competition_20201019.81238614.png";